import React from "react";
import { Link } from "@mui/material";

const DocLink: React.FC<{ url?: string | null }> = ({ url }) =>
  url ? (
    <Link href={url} target="_blank" rel="noopener noreferrer">
      View document
    </Link>
  ) : null;

export default DocLink;
